module.exports = __webpack_public_path__ + "static/ArialBold-76a58b2ac24885f55d96f5300a14e059.ttf";